import { Button } from "@shared/ui.primitives";
import React, { useEffect, useRef } from "react";

import type { ProductCardDataType } from "./types";

type Props = {
  product: Pick<
    ProductCardDataType,
    "buttonText" | "isPrimaryButtonDisabled" | "prices" | "inStock"
  >;
  onClick?: () => void;
  variant?: "primary" | "secondary";
};

export const HorizontalProductCardButton: React.FC<Props> = ({
  product,
  onClick,
  variant = "primary"
}) => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (buttonRef && buttonRef.current) {
      buttonRef.current.dataset.testRenderState = "complete";
    }
  }, [product.buttonText]);

  return (
    <Button
      ref={buttonRef}
      variant={variant}
      size="small"
      onClick={(event) => {
        event?.preventDefault();
        event?.stopPropagation();
        onClick?.();
      }}
      disabled={product.isPrimaryButtonDisabled}
      text={product.buttonText}
    />
  );
};
